(function(callback){
    // Check if jQuery is defined
    if (typeof jQuery === 'undefined') {
        // Load jQuery from CDN
        var script = document.createElement('script');
        script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
        script.type = 'text/javascript';
        script.onload = callback; // run code after jQuery loads
        document.getElementsByTagName('head')[0].appendChild(script);
    } else {
        // jQuery already loaded
        callback();
    }
})(function(){
    console.log('jQuery loaded');
    // SHA-256 helper (returns Promise)
    function sha256(value) {
        if (!value) return Promise.resolve(null);
        var msgBuffer = new TextEncoder().encode(value.trim().toLowerCase());
        return crypto.subtle.digest('SHA-256', msgBuffer).then(function(hashBuffer){
            var hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map(function(b){ return b.toString(16).padStart(2,'0'); }).join('');
        });
    }

    // Normalize phone (digits only)
    function normalizePhone(phone) {
        return phone.replace(/\D/g, '');
    }

// var popupChecker = setInterval(function(){
//     var widget = $('#one-click-popup-main-content');

//     if(!widget.length) return; // popup not open yet

//     var email = widget.find('input[type="email"]').val() || '';
//     var phoneRaw = widget.find('input[type="tel"]').val() || '';
//     var phone = phoneRaw.replace(/\D/g, '');

//     // Only fire once
//     if(email.trim() !== '' && !widget.data('lead-fired')){
//         widget.data('lead-fired', true); // mark as fired

//         // Hash and send Pixel
//         sha256(email).then(function(hashedEmail){
//             if(phone){
//                 sha256(phone).then(function(hashedPhone){
//                     fbq('track','Lead',{em:hashedEmail, ph:hashedPhone});
//                     console.log('Lead fired:', hashedEmail, hashedPhone, email);
//                 });
//             } else {
//                 fbq('track','Lead',{em:hashedEmail});
//                 console.log('Lead fired:', hashedEmail, '(no phone)');
//             }
//         });

//         // Stop checking once fired
//         clearInterval(popupChecker);
//     }
// }, 100);
setTimeout(function(){
    var popup = $('#modal-signup-main-content');
    if (popup.length > 0) {

        
        var button = popup.find('.primary-action-button');

        // Disable button initially
        button.css({
            'opacity': 0.5,
            'pointer-events': 'none'
        });


        // Inject checkbox if not already added
        if($('#meta_request').length === 0){
            $('#modal-signup-custom-fields').append(`
                <label for="meta_request" style="display: flex; gap: 4px; align-items: center; cursor: pointer; color: #fff;">
                    <input type="checkbox" id="meta_request" name="meta_request" value="I agree to the terms." required>
                    I agree to the terms. *
                </label>
            `);
        }

        // Fire Pixel when checkbox changes
        $(document).on('change', '#meta_request', function(){
            var checkbox = $(this).is(':checked');
            if(!checkbox) return; // do nothing if unchecked

            var email = popup.find('input[type="email"]').val() || '';
            var phone = (popup.find('input[type="tel"]').val() || '').replace(/\D/g,'');
            var name = popup.find('input[name="first_name"]').val() || '';

            // Only fire Pixel if name and email/phone exist
            if(email.trim() && phone.trim() && name.trim()){
                sha256(email).then(function(hashedEmail){
                    sha256(phone).then(function(hashedPhone){
                        fbq('track','Lead',{
                            em: hashedEmail,
                            ph: hashedPhone,
                            fn: name
                        });
                        console.log('Lead fired:', hashedEmail, hashedPhone, name);
                    });
                });
                button.css({
                    'opacity': 1,
                    'pointer-events': 'auto'
                });
            } else {
                console.log('Checkbox checked but some fields are empty, Pixel not fired');
            }
        });
    }
},1000);





// setTimeout(function(){
//     $(document).click('#modal-signup-main-content .button',function(e){
//         e.preventDefault();
//         var widget = $('#modal-signup-main-content');
//         var email = widget.find('input[type="email"]').val() || '';
//         var phoneRaw = widget.find('input[type="tel"]').val() || '';
//         var phone = phoneRaw.replace(/\D/g, '');

//         if (email) {
//             sha256(email).then(function(hashedEmail){
//                 if(phone){
//                     sha256(phone).then(function(hashedPhone){
//                         fbq('track','Lead',{em:hashedEmail, ph:hashedPhone});
//                         console.log('Lead fired: Phone and email', hashedEmail, hashedPhone, email);
//                     });
//                 } else {
//                     fbq('track','Lead',{em:hashedEmail});
//                     console.log('Lead fired: email only', hashedEmail, '(no phone)');
//                 }
//             });
//         } else {
//             console.log('Fields are empty');
//         }
//     });
// },200);

});
